import { ModelService } from 'ng2-app/modules/shared/services/model.service';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { lastValueFrom, Observable } from 'rxjs';
import { StateService } from 'ng2-app/modules/shared/services/state.service';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { ApiHttpClient } from 'app/http/clients/api';

interface ActivityType {
    id: string;
    name: string;
    count: number;
}

@Injectable()
export class ActivityService extends ModelService<Activity> {
    protected urlPath = '/activity';

    constructor(
        http: ApiHttpClient,
        private stateService: StateService
    ) {
        super(http);
    }

  getActivityTypes(params: HttpParams): Promise<ActivityType[]> {
    return lastValueFrom(this.http.get('/activity-types', {
      params
    })) as Promise<ActivityType[]>;
  }

  /**
     * Emits a single activity, as they are added, updated or deleted.
     *
     * @param borrowerId
     */
    forBorrower(borrowerId: number): Observable<Activity> {
        return this.stateService.stream<Activity>(`borrower/${borrowerId}/activities`).pipe(
            map(attrs => this.createFromResponseData(attrs))
        );
    }

    protected createFromResponseData(responseData: any): Activity {
        // Add the filename and size to the activity meta in order to use them directly in pipeline
        // when file are deleted on the activity tab
        if (responseData.meta) {
            if (!responseData.filename && responseData.meta.filename) {
              responseData['filename'] = responseData.meta.filename;
            }
            if (!responseData.size && responseData.meta.size) {
              responseData['size'] = responseData.meta.size;
            }
          }
        // gather all other type-specific attributes into `meta`
        return new Activity(Object.assign({}, responseData, {
            meta: _.omit(responseData, new Activity().fillable())

        }));
    }
}
